import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import estateImage from '../../assets/esetate.jpg';

const BRAND = {
  cyan: '#00AEEF',
  magenta: '#EC008C',
  red: '#ED1C24',
};

const SLIDE_DURATION = 4500;

const SparklesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={BRAND.cyan} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
  </svg>
);

const ChevronLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6" /></svg>
);

const ChevronRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6" /></svg>
);

const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" /><circle cx="12" cy="10" r="3" /></svg>
);

const BedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8" /><path d="M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" /><path d="M12 4v6" /><path d="M2 18h20" /></svg>
);

const BathIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 4 8 6" /><path d="M17 19v2" /><path d="M2 12h20" /><path d="M7 19v2" /><path d="M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" /></svg>
);

const ExpandIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 15 6 6" /><path d="m15 9 6-6" /><path d="M21 16v5h-5" /><path d="M21 8V3h-5" /><path d="M3 16v5h5" /><path d="m3 21 6-6" /><path d="M3 8V3h5" /><path d="M9 9 3 3" /></svg>
);

const ArrowUpRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"><path d="M7 7h10v10" /><path d="M7 17 17 7" /></svg>
);

const properties = [
  {
    id: 1,
    title: 'MHADA Shirdhon',
    location: 'Shirdhon, Kalyan',
    price: '₹15.44 L',
    image: estateImage,
    amenities: [
      { id: 'bed', icon: <BedIcon />, text: '1 BHK' },
      { id: 'bath', icon: <BathIcon />, text: '1 Bath' },
      { id: 'sqft', icon: <ExpandIcon />, text: '321.84 sq.ft' },
    ],
  },
  {
    id: 2,
    title: 'MHADA Shirdhon',
    location: 'Shirdhon, Kalyan',
    price: '₹19.85 L',
    image: estateImage,
    amenities: [
      { id: 'bed', icon: <BedIcon />, text: '1 BHK' },
      { id: 'bath', icon: <BathIcon />, text: '1 Bath' },
      { id: 'sqft', icon: <ExpandIcon />, text: '321.84 sq.ft' },
    ],
  },
  {
    id: 3,
    title: 'MHADA Khoni',
    location: 'Khoni, Kalyan',
    price: '₹18.21 L',
    image: estateImage,
    amenities: [
      { id: 'bed', icon: <BedIcon />, text: '1 BHK' },
      { id: 'bath', icon: <BathIcon />, text: '1 Bath' },
      { id: 'sqft', icon: <ExpandIcon />, text: '321.72 sq.ft' },
    ],
  },
  {
    id: 4,
    title: 'MHADA Khoni',
    location: 'Khoni, Kalyan',
    price: '₹19.67 L',
    image: estateImage,
    amenities: [
      { id: 'bed', icon: <BedIcon />, text: '1 BHK' },
      { id: 'bath', icon: <BathIcon />, text: '1 Bath' },
      { id: 'sqft', icon: <ExpandIcon />, text: '321.72 sq.ft' },
    ],
  },
];

const BRAND_COLORS = [BRAND.cyan, BRAND.magenta, BRAND.red, BRAND.cyan];

export default function FeaturedProperties() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev === properties.length - 1 ? 0 : prev + 1));
    }, SLIDE_DURATION);
    return () => clearInterval(timer);
  }, [activeIndex]);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const handleNext = () =>
    setActiveIndex((prev) => (prev === properties.length - 1 ? 0 : prev + 1));

  const handlePrev = () =>
    setActiveIndex((prev) => (prev === 0 ? properties.length - 1 : prev - 1));

  return (
    <section
      ref={sectionRef}
      className="relative z-0 overflow-hidden px-4 pb-20 pt-16 md:px-10 md:pb-28 md:pt-20 font-display bg-white"
    >
      {/* Light gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-white via-slate-50 to-white pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 h-64 bg-gradient-to-b from-[#00AEEF]/8 via-[#EC008C]/5 to-transparent pointer-events-none" />
      <div className="absolute top-1/3 -left-24 w-72 h-72 rounded-full bg-[#00AEEF]/12 blur-[90px] pointer-events-none" />
      <div className="absolute bottom-1/4 -right-24 w-80 h-80 rounded-full bg-[#EC008C]/10 blur-[100px] pointer-events-none" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-48 bg-gradient-to-t from-[#ED1C24]/6 to-transparent blur-2xl pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 h-1 ses-brand-gradient opacity-60" />

      <div className="relative mx-auto w-full max-w-6xl">
        {/* Header */}
        <div
          className={`about-reveal mb-10 flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between ${visible ? 'about-visible' : ''}`}
        >
          <div className="min-w-0">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full p-[1.5px] ses-brand-gradient shadow-sm">
              <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-slate-600">
                <SparklesIcon />
                Curated Picks
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
              Featured{' '}
              <span className="ses-brand-text">Properties</span>
            </h2>
            <p className="mt-3 max-w-lg text-base text-slate-500 leading-relaxed">
              Handpicked MHADA homes offering the best value, location, and lifestyle in Kalyan.
            </p>
          </div>

          <div className="flex shrink-0 items-center gap-5">
            <span className="font-mono text-sm tabular-nums text-slate-400">
              <span className="text-3xl font-black ses-brand-text">
                {String(activeIndex + 1).padStart(2, '0')}
              </span>
              <span className="mx-1.5">/</span>
              {String(properties.length).padStart(2, '0')}
            </span>
            <div className="flex gap-2">
              <button
                onClick={handlePrev}
                type="button"
                aria-label="Previous property"
                className="flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 shadow-sm transition-all hover:border-[#00AEEF] hover:text-[#00AEEF] hover:shadow-[0_4px_20px_rgba(0,174,239,0.2)] hover:-translate-y-0.5"
              >
                <ChevronLeftIcon />
              </button>
              <button
                onClick={handleNext}
                type="button"
                aria-label="Next property"
                className="flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 shadow-sm transition-all hover:border-[#EC008C] hover:text-[#EC008C] hover:shadow-[0_4px_20px_rgba(236,0,140,0.2)] hover:-translate-y-0.5"
              >
                <ChevronRightIcon />
              </button>
            </div>
          </div>
        </div>

        {/* Main carousel */}
        <div
          className={`about-reveal relative w-full rounded-[2rem] p-[2px] ses-brand-gradient ${visible ? 'about-visible' : ''}`}
          style={{ transitionDelay: '150ms', '--slide-duration': `${SLIDE_DURATION}ms` }}
        >
          <div className="relative w-full overflow-hidden rounded-[1.9rem] bg-white min-h-[480px] sm:min-h-0 sm:aspect-[4/3] md:aspect-[21/9] shadow-xl shadow-slate-200/60">
            {/* Progress bar */}
            <div className="absolute inset-x-0 top-0 z-30 h-1 bg-white/10">
              <div key={activeIndex} className="h-full ses-brand-gradient featured-progress" />
            </div>

            {properties.map((property, idx) => {
              const isActive = activeIndex === idx;
              const accent = BRAND_COLORS[idx % BRAND_COLORS.length];

              return (
                <div
                  key={property.id}
                  className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                    isActive ? 'opacity-100 z-20' : 'opacity-0 z-10 pointer-events-none'
                  }`}
                >
                  <div
                    className={`absolute inset-0 bg-cover bg-center ${isActive ? 'featured-ken-burns' : ''}`}
                    style={{ backgroundImage: `url('${property.image}')` }}
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10" />
                  <div
                    className="absolute inset-0 opacity-50"
                    style={{
                      background: `linear-gradient(135deg, ${BRAND.cyan}22, transparent 40%, ${BRAND.magenta}18, transparent 70%, ${BRAND.red}15)`,
                    }}
                  />

                  <div className="relative z-10 flex h-full flex-col justify-end p-5 sm:p-8 md:p-10">
                    <div
                      className={`w-full transform transition-all duration-700 delay-200 ${
                        isActive ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                      }`}
                    >
                      <div className="max-w-3xl space-y-4">
                        <div className="inline-flex items-center gap-2 rounded-full p-[1.5px] ses-brand-gradient">
                          <span className="inline-flex items-center gap-2 rounded-full bg-black/40 backdrop-blur-md px-3.5 py-1.5 text-[10px] sm:text-xs font-bold uppercase tracking-widest text-white">
                            <span className="relative flex h-1.5 w-1.5">
                              <span
                                className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-60"
                                style={{ background: BRAND.cyan }}
                              />
                              <span
                                className="relative inline-flex rounded-full h-1.5 w-1.5"
                                style={{ background: BRAND.cyan }}
                              />
                            </span>
                            MHADA Approved
                          </span>
                        </div>

                        <div>
                          <h3 className="text-2xl sm:text-3xl md:text-5xl font-extrabold leading-tight text-white">
                            {property.title}
                          </h3>
                          <p className="mt-2 flex items-center gap-2 text-sm md:text-base text-white/60 font-medium">
                            <MapPinIcon />
                            {property.location}
                          </p>
                        </div>

                        <div className="flex flex-wrap gap-2 sm:gap-3">
                          {property.amenities.map((amenity) => (
                            <span
                              key={amenity.id}
                              className="inline-flex items-center gap-2 rounded-xl border border-white/20 bg-white/15 px-3 py-1.5 text-xs sm:text-sm text-white backdrop-blur-sm"
                            >
                              <span style={{ color: accent }}>{amenity.icon}</span>
                              {amenity.text}
                            </span>
                          ))}
                        </div>
                      </div>

                      <div className="mt-6 flex w-full flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
                        <p className="text-3xl sm:text-4xl font-black ses-brand-text tracking-tight">
                          {property.price}
                        </p>

                        <Link
                          to={`/property/${property.id}`}
                          className="group relative inline-flex w-full sm:w-auto justify-center items-center gap-2 overflow-hidden rounded-2xl px-8 py-4 text-sm font-bold text-white transition-all hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(0,174,239,0.35)]"
                        >
                          <span className="absolute inset-0 ses-brand-gradient opacity-90 group-hover:opacity-100 transition-opacity" />
                          <span className="relative">View Details</span>
                          <ArrowUpRightIcon />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Thumbnail strip */}
        <div
          className={`about-reveal mt-5 w-full ${visible ? 'about-visible' : ''}`}
          style={{ transitionDelay: '300ms' }}
        >
          <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
            {properties.map((property, idx) => {
              const isActive = activeIndex === idx;
              const accent = BRAND_COLORS[idx % BRAND_COLORS.length];

              if (isActive) {
                return (
                  <button
                    key={`thumb-${property.id}`}
                    onClick={() => setActiveIndex(idx)}
                    type="button"
                    className="group flex shrink-0 items-center gap-3 rounded-2xl p-[2px] ses-brand-gradient text-left transition-all duration-300 scale-[1.02] shadow-lg"
                  >
                    <div className="flex items-center gap-3 rounded-[0.9rem] bg-white p-2.5 pr-5">
                      <div className="relative shrink-0">
                        <div
                          className="absolute -inset-0.5 rounded-xl opacity-50 blur-sm"
                          style={{ background: accent }}
                        />
                        <div
                          className="relative h-12 w-12 sm:h-14 sm:w-14 rounded-xl bg-cover bg-center ring-2 ring-white"
                          style={{ backgroundImage: `url('${property.image}')` }}
                        />
                      </div>
                      <div className="min-w-0">
                        <p className="max-w-[140px] sm:max-w-[180px] truncate text-xs sm:text-sm font-bold text-slate-900">
                          {property.title}
                        </p>
                        <p className="truncate text-[10px] sm:text-xs mt-0.5 text-slate-500">
                          {property.location}
                        </p>
                        <p className="mt-1 truncate text-[10px] sm:text-xs font-bold ses-brand-text">
                          {property.price}
                        </p>
                      </div>
                    </div>
                  </button>
                );
              }

              return (
                <button
                  key={`thumb-${property.id}`}
                  onClick={() => setActiveIndex(idx)}
                  type="button"
                  className="group flex shrink-0 items-center gap-3 rounded-2xl border border-slate-200 bg-white p-2.5 pr-5 text-left shadow-sm transition-all duration-300 hover:border-slate-300 hover:shadow-md hover:-translate-y-0.5"
                >
                  <div
                    className="h-12 w-12 sm:h-14 sm:w-14 shrink-0 rounded-xl bg-cover bg-center"
                    style={{ backgroundImage: `url('${property.image}')` }}
                  />
                  <div className="min-w-0">
                    <p className="max-w-[140px] sm:max-w-[180px] truncate text-xs sm:text-sm font-bold text-slate-800">
                      {property.title}
                    </p>
                    <p className="truncate text-[10px] sm:text-xs mt-0.5 text-slate-500">
                      {property.location}
                    </p>
                    <p
                      className="mt-1 truncate text-[10px] sm:text-xs font-bold"
                      style={{ color: accent }}
                    >
                      {property.price}
                    </p>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
